const signedDefaultPermissions = [
    {
        link: '/dashboard'
    },
    {
        link: '/grupo_permissoes/:grupoId'
    },
    {
        link: '/perfil'
    },
    {
        link: '/not_allowed'
    },
    {
        link: '/relatorio/:grupoId'
    },
    {
        link: '/gerenciar/:entidade'
    },
    {
        link: '/perfil/:id'
    },
    {
        link: '/projeto/:id'
    }
]

const unsignedDefaultPermissions = [
    {
        link: '/'
    },
    {
        link: '/cadastro'
    },
    {
        link: '/signup'
    },
    {
        link: '/not_allowed'
    },
    {
        link: '/pass_recover'
    },
    {
        link: '/pass_recover/:token/:crm'
    },
    {
        link: '/socket'
    }
]

export {
    unsignedDefaultPermissions,
    signedDefaultPermissions
}
